import React, { useEffect, useState } from 'react';
import {
  CenterButtonContainer,
  TextBold,
  TextRegular,
} from '../../../styles/GlobalStyledComponents';
import Button from '../../../components/Button/Button';
import { colors } from '../../../styles/Colors';
import ModalImgDivSvg from '../../../assets/images/NoDebt/NoDebt.svg';
import IframeService from '../../../services/Iframe';
import TokenService from '../../../services/Token';
import { ROUTES_PATH } from '../../../constants';
import { useDebtResult } from '../../../contexts/DebtContext';
import {
  StandardPaymentType,
  StandardPaymentsData,
  TransactionReasonEnum,
} from '../../../interfaces/Debt';
import { usePaymentSelected } from '../../../contexts/PaymentSelectedContext';
import FinancialService from '../../../services/Financial';
import { useUserResult } from '../../../contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import { useCardsResult } from '../../../contexts/CardsContext';
import { webviewMessage } from '../../../utils/webviewHelper';
import GAnalyticsService from '../../../services/GAnalytics/ganalytics.service';
import dayjs from 'dayjs';
import {
  ImgWrapper,
  ModalImgDiv,
  ModalTextWrapper,
  ModalWrapper,
} from '../FinalModalStyledComponents';
import { ViewMode } from '../../../interfaces/Mode';
import { getRedirectionUrl, getUtmParams } from '../../../utils/urlParams';

const NoDebt = () => {
  const navigate = useNavigate();
  const { red4, white } = colors;
  const { debtResult } = useDebtResult();
  const { userResult } = useUserResult();
  const { createCardsResult } = useCardsResult();
  let cardList: { payment_method_id: any }[] = [];
  const [advanceFee, setAdvanceFee] = useState<Boolean>();
  const [initTime] = useState<dayjs.Dayjs>(dayjs());
  const { createPaymentSelected } = usePaymentSelected();

  const viewMode = sessionStorage.getItem('pepper-view-mode');
  localStorage.setItem('come-from-nodebt', 'true');
  const advanceFeeOK = sessionStorage.getItem('advance-fee-OK') === 'true';
  const finalParams = getUtmParams(true);

  const goToClientArea = () => {
    if (
      viewMode === ViewMode.APP ||
      viewMode === ViewMode.IFRAME ||
      viewMode === ViewMode.CLIENTES
    ) {
      if (viewMode === ViewMode.APP) {
        webviewMessage({ data: 'no debt' });
      } else if (viewMode === ViewMode.CLIENTES) {
        const winRef = window.opener;
        if (winRef) {
          const targetOrigin = document.referrer;
          winRef.postMessage('no debt', targetOrigin);
        }
      } else {
        IframeService.closeIframe('no debt');
      }
      TokenService.clearSession();
    } else {
      TokenService.clearSession();
      window.location.href = getRedirectionUrl(finalParams);
    }
  };

  const handleAdvanceFee = async () => {
    if (userResult && debtResult) {
      sessionStorage.setItem('able-to-advance-fee', 'false');
      sessionStorage.setItem('advance-fee', 'true');

      const cards = await FinancialService.getPaymentCards(
        userResult?.document_id as string,
      );
      createCardsResult(cards);
      cardList.push(cards?.payment_methods[0]);
      GAnalyticsService.savePaymentMethodsDataLayer(cards);
      GAnalyticsService.sendInAdvancePayment(initTime);
      //SE CREA EL NUEVO PAGO
      const newPayment: StandardPaymentsData = {
        amount: parseFloat(Number(debtResult?.promotions[0].amount).toFixed(2)),
        amount_excused: parseFloat(
          Number(debtResult?.promotions[0].amount_excused).toFixed(2),
        ),
        loan_id: debtResult?.promotions[0].loan_id as string,
        transaction_reason: TransactionReasonEnum.PAN,
        type: StandardPaymentType.PayFee,
      };
      createPaymentSelected(newPayment);
      navigate(ROUTES_PATH.TYPES_PAYMENTS);
    }
  };

  useEffect(() => {
    if (debtResult?.promotions.length === 0) {
      setAdvanceFee(false);
    } else {
      setAdvanceFee(true);
    }
  }, [debtResult?.promotions]);

  useEffect(() => {
    GAnalyticsService.sendNoDebtEvent();
  }, []);

  if (advanceFee && !advanceFeeOK) {
    return (
      <ModalWrapper id="no-debt-page">
        <ImgWrapper>
          <ModalImgDiv
            src={ModalImgDivSvg}
            alt="no debt"
            title="no debt image"
            width={''}
            height={''}
          />
        </ImgWrapper>
        <ModalTextWrapper>
          <TextBold
            id="no-debt-title"
            fontSize={24}
            align="center"
            lineHeight={32}
            fontWeight={700}
          >
            ¡Hola {userResult?.name}!
          </TextBold>
        </ModalTextWrapper>
        <ModalTextWrapper>
          <TextRegular
            id="no-debt-text"
            fontSize={18}
            fontWeight={400}
            lineHeight={24}
            color="gray6"
          >
            ¡Enhorabuena, todos tus pagos están al día! 😃
          </TextRegular>
        </ModalTextWrapper>
        <ModalTextWrapper>
          <TextRegular
            id="no-debt-text"
            fontSize={16}
            fontWeight={400}
            lineHeight={22}
            color="gray6"
          >
            Recuerda que en la App Pepper Clientes puedes consultar el detalle
            de tus financiaciones.
          </TextRegular>
        </ModalTextWrapper>
        <CenterButtonContainer>
          <Button
            click={() => handleAdvanceFee()}
            color={white}
            borderColor={red4}
            backgroundColor={red4}
            minWidth="280px"
            id="advance-fee-btn"
          >
            <TextRegular
              fontSize={18}
              color={white}
              lineHeight={20}
              fontWeight={700}
            >
              {/*  Adelantar cuota (
              {debtResult && pricesHelper(debtResult?.promotions[0].amount)}€){' '} */}
              Adelanta la próxima cuota
            </TextRegular>
          </Button>
          {viewMode !== ViewMode.IFRAME && (
            <Button
              color={red4}
              border="2px solid"
              borderColor={red4}
              backgroundColor={white}
              minWidth="280px"
              click={() => goToClientArea()}
              id="client-area-btn"
            >
              <TextRegular
                fontSize={18}
                color={white}
                lineHeight={20}
                fontWeight={700}
              >
                Área Cliente
              </TextRegular>
            </Button>
          )}
        </CenterButtonContainer>
      </ModalWrapper>
    );
  } else {
    return (
      <ModalWrapper id="no-debt-page">
        <ImgWrapper>
          <ModalImgDiv
            src={ModalImgDivSvg}
            alt="no debt"
            title="no debt image"
            width={''}
            height={''}
          />
        </ImgWrapper>
        <ModalTextWrapper>
          <TextBold
            id="no-debt-title"
            fontSize={24}
            align="center"
            lineHeight={32}
            fontWeight={700}
          >
            ¡Hola {userResult?.name}!
          </TextBold>
        </ModalTextWrapper>
        <ModalTextWrapper>
          <TextRegular
            id="no-debt"
            fontSize={18}
            fontWeight={400}
            lineHeight={24}
            color="gray6"
          >
            ¡Enhorabuena, todos tus pagos están al día! 😃
          </TextRegular>
        </ModalTextWrapper>
        <ModalTextWrapper>
          <TextRegular
            id="no-debt-text"
            color="gray6"
            fontSize={16}
            fontWeight={400}
            lineHeight={22}
          >
            Recuerda que en la App Pepper Clientes puedes consultar el detalle
            de tus financiaciones.
          </TextRegular>
        </ModalTextWrapper>
        {viewMode !== ViewMode.IFRAME && (
          <CenterButtonContainer>
            <Button
              color={red4}
              border="2px solid"
              borderColor={red4}
              backgroundColor={white}
              minWidth="280px"
              click={() => goToClientArea()}
              id="client-area-btn"
            >
              <TextRegular
                fontSize={18}
                color={white}
                lineHeight={20}
                fontWeight={700}
              >
                Área Cliente
              </TextRegular>
            </Button>
          </CenterButtonContainer>
        )}
      </ModalWrapper>
    );
  }
};

export default NoDebt;
